import { Add, Delete, Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { OfferMailOrderShipmentDto } from "../product/common";
import { OfferMailOrderShipmentDialog } from "../product/OfferMailOrderShipmentDialog";
import { useOfferMailOrderShipments, usePaymentMethods } from "../../common/enum";
import { SaleArticleDto } from "../../common/order";

export function OfferMailOrderShipmentListPage() {
    const [useShipmentsStore] = useState(() => createListStore<OfferMailOrderShipmentDto>({
        path: "offerMailOrderShipments",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "ID", width: 70, type: "number" },
            { column: "dsc", label: "Description", width: 300 },
            { column: "paymentMethodId", label: "Payment method", width: 120, enumStore: usePaymentMethods },
            { column: "dscAmt", label: "Discount", width: 120, type: "currency" },
            { column: "btoAmt", label: "Total price", width: 120, type: "currency" },
            { column: "rdcInvcAmt", label: "To pay", width: 120, type: "currency" },
        ],
    }));

    const [useSaleArticleListStore] = useState(() => createListStore<SaleArticleDto>({ path: "saleArticles" }));
    const shipmentsStore = useShipmentsStore(p => ({ selectedItem: p.selectedItem }));

    const newDialog = useDialog(close => <OfferMailOrderShipmentDialog close={close} useArticleListStore={useSaleArticleListStore}
        shipmentId={null} useShipmentsStore={useShipmentsStore} />);
    const editDialog = useDialog(close => <OfferMailOrderShipmentDialog close={close} useArticleListStore={useSaleArticleListStore}
        shipmentId={shipmentsStore.selectedItem?.id!} useShipmentsStore={useShipmentsStore} />);
    const simpleDialog = useSimpleDialog();

    async function deleteItem() {
        await simpleDialog.show("Mail order templates", "Delete selected mail order template?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`offerMailOrderShipments/${shipmentsStore?.selectedItem?.id}`);
            }
            finally {
                useShipmentsStore.getState().fetch();
                useOfferMailOrderShipments.getState().uninit();
            }
        }));
    }

    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Mail order templates" />
        {renderListStore(useShipmentsStore, {
            onDoubleClick: () => editDialog.show(), header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={shipmentsStore.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={shipmentsStore.selectedItem == null} title="Delete" onClick={deleteItem}><Delete /></Button>],
            ]),
        })}
    </>;
}
